import React, { useMemo, useState } from "react";
import CustomTable, { Column } from "../../../../components/CustomTable";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import StaticModal from "../../../../components/staticModel";
import TeamForm from "./forms/TeamForm";
import {
  ProjectDetailResponse,
  ProjectUser,
} from "../../../../model/projectModel";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const TeamMember: React.FC<{ details: ProjectDetailResponse | null }> = ({
  details,
}) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editFormValue, setEditFormValue] = useState<ProjectUser | null>(null);
  const [formType, setFormType] = useState<string>("create");
  const [memberFilterValue, setMemberFilterValue] = useState<string>("");
  const [statusValueData, setStateValueData] = useState<string>("active");

  // const teamMember = useMemo(() => {
  //   return details?.users
  //     ? details.users
  //         .filter((member) => {
  //           const matchesName = member["Employee Name"]
  //             .toLowerCase()
  //             .includes(memberFilterValue.toLowerCase());
  //           const matchesStatus =
  //             statusValueData === "active"
  //               ? member.end_ts === null
  //               : statusValueData === "inactive"
  //                 ? member.end_ts !== null
  //                 : true;
  //           return matchesName && matchesStatus;
  //         })
  //         .map((item, index) => {
  //           return {
  //             ...item,
  //             id: index + 1,
  //             start: moment(item.start_ts).isValid()
  //               ? moment(item.start_ts).format("DD/MM/YYYY")
  //               : "",
  //             end: moment(item.end_ts).isValid()
  //               ? moment(item.end_ts).format("DD/MM/YYYY")
  //               : "",
  //             user_type:
  //               item.is_approver === "No" && item.isaltmanager === "No"
  //                 ? "User"
  //                 : item.is_approver === "Yes" &&
  //                     item["Employee ldap"] === details.manager
  //                   ? "Approver & Manager"
  //                   : item.is_approver === "Yes"
  //                     ? "Approver"
  //                     : "User & Approver",
  //           };
  //         })
  //     : null;
  // }, [details, memberFilterValue, statusValueData]);
  const teamMember = useMemo(() => {
    return details?.users
      ? details.users
          .filter((member) => {
            const matchesName = member["Employee Name"]
              .toLowerCase()
              .includes(memberFilterValue.toLowerCase());
            const endMoment = moment(member.end_ts);
            // FIX: Check if end date is null OR is today/in the future
            const isMemberActive =
              member.end_ts === null ||
              (endMoment.isValid() && endMoment.isSameOrAfter(moment(), "day"));

            const matchesStatus =
              statusValueData === "active"
                ? isMemberActive
                : statusValueData === "inactive"
                  ? !isMemberActive
                  : true;

            return matchesName && matchesStatus;
          })
          .map((item, index) => {
            return {
              ...item,
              id: index + 1,
              start: moment(item.start_ts).isValid()
                ? moment(item.start_ts).format("DD/MM/YYYY")
                : "",
              end: moment(item.end_ts).isValid()
                ? moment(item.end_ts).format("DD/MM/YYYY")
                : "",
              user_type:
                item.is_approver === "No" && item.isaltmanager === "No"
                  ? "User"
                  : item.is_approver === "Yes" &&
                      item["Employee ldap"] === details.manager
                    ? "Approver & Manager"
                    : item.is_approver === "Yes"
                      ? "Approver"
                      : "User & Approver",
            };
          })
      : null;
  }, [details, memberFilterValue, statusValueData]);

  const columns: Column<ProjectUser>[] = [
    {
      header: "Employee Name",
      key: "Employee Name",
      enableLink: true,
      path: "/",
    },
    {
      header: "Billable",
      key: "is_billable",
      enableLink: false,
      path: "",
    },
    { header: "Location", key: "location", enableLink: false, path: "" },
    { header: "Start Date", key: "start", enableLink: false, path: "" },
    { header: "End Date", key: "end", enableLink: false, path: "" },
    {
      header: "Shift Details",
      key: "shift_details",
      enableLink: false,
      path: "",
    },
    { header: "User Type", key: "user_type", enableLink: false, path: "" },
    {
      header: "Approver Name [LDAP User Id]",
      key: "Approver Name",
      enableLink: false,
      path: "",
    },
  ];

  const handleMemberChange = (selectedOption: string | null) => {
    setMemberFilterValue?.(selectedOption ?? "");
  };

  const handleTableRefresh = () => {
    setStateValueData("active");
    setMemberFilterValue("");
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleEdit = (data: number) => {
    if (data && teamMember && teamMember?.length > 0) {
      const editValue = teamMember.filter((item) => item.id === data);
      setEditFormValue(editValue[0] ?? null);
      setFormType("update");
      openModal();
    }
  };

  const handleNavigation = (path: string | undefined, states: number) => {
    navigate(path ?? "", { state: { id: states } }); // Navigate to the specified path with state
  };

  return (
    <>
      {" "}
      <button
        type="button"
        onClick={() => {
          setFormType("create");
          openModal();
        }}
        className="text-white mb-3 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-4 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        Add Team Member
      </button>
      <div className="max-w-4xl gap-x-6 gap-y-8 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ">
        <div>
          <label
            htmlFor="start-end-date"
            className="block text-sm font-medium leading-6 text-gray-900 dark:text-white"
          >
            Search a member
          </label>
          <div className="mt-2">
            <select
              value={memberFilterValue}
              onChange={(e) => handleMemberChange(e.target.value)}
              className="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            >
              <option selected value="">
                All
              </option>
              {details?.users.map((item) => (
                <option key={item["Employee id"]} value={item["Employee Name"]}>
                  {item["Employee Name"]}
                </option>
              ))}
            </select>
            {/* <Select
              className='basic-single'
              defaultValue={details?.users.find((item) =>
                item["Employee Name"].toLowerCase().includes(memberFilterValue),
              )}
              onChange={(e: unknown) =>  handleMemberChange(e.value as string)}
              isClearable
              isSearchable
              options={details?.users.map((item) => {
                return { ...item, label: item["Employee Name"], value: item["Employee Name"] };
              })}
              styles={CustomSelectStyles}
            /> */}
          </div>
        </div>
        <div>
          <label
            htmlFor="status"
            className="block text-sm font-medium leading-6 text-gray-900 dark:text-white"
          >
            Status
          </label>
          <div className="mt-2">
            <select
              id="status"
              value={statusValueData}
              onChange={(e) => setStateValueData(e.target.value)}
              className="shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light"
            >
              <option selected>Select</option>
              <option value="active">Active</option>
              <option value="inactive">InActive</option>
            </select>
          </div>
        </div>
        <div className="flex space-x-4">
          {/* <button
            onClick={() => handleTableRefresh()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <MagnifyingGlassIcon className='h-5 w-5 text-white' />
          </button> */}
          <button
            onClick={() => handleTableRefresh()}
            className="flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none "
          >
            <ArrowPathIcon className="h-5 w-5 text-white" />
          </button>
        </div>
      </div>
      <CustomTable
        idKeyName={"id"}
        showFilter={false}
        columns={columns}
        data={teamMember ?? []}
        modelForm={true}
        handleModel={handleEdit}
        handleNavigation={handleNavigation}
      />
      <StaticModal
        headerName="Team Member"
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <TeamForm
          formType={formType}
          userValue={editFormValue}
          closeModals={closeModal}
        />
      </StaticModal>
    </>
  );
};

export default TeamMember;
